import { useContextState } from "../../../../../../../../hooks/theme"


const useStyles = () => {
  const { colors } = useContextState()

  return {
    checkBox: { 
      padding: '0px' 
    },
    drawerTitle: {
      /* fontSize: '14px',
      color: colors.color13,
      marginBottom: '20px', */
      color: colors.color13,
      '&.wSc':{
        whiteSpace: 'pre-line'
      }
    },
    drawer: {
      position: 'relative',
      '& .MuiPaper-root': {
        '&:not(:last-child)': {
          marginBottom: '15px',
        },
        width: '400px',
        padding: '50px 0px 10px',
      },
    },
    body: {
      padding: '0px 40px',
      height: 'calc(100% - 60px)',
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      gap:3
    },
    containerFooter: {
      padding: '0px 40px',
      /* width: 'calc(100% - 80px)', */
      width:'100%',
      position: 'absolute',
      bottom: '20px',
      display: 'flex',
      justifyContent: 'space-between'
    },
    cleanFilters: {
      fontSize: '14px',
      cursor: 'pointer',
      color: colors.color16,
      minHeight: '35px',
      marginTop: '10px',
      display: 'flex',
      alignItems: 'center',
    },
    iconClose: {
      position: 'absolute',
      top: '5px',
      right: '5px',
      color: colors.color13,
    },
  }
}

export { useStyles }
